import React from 'react'

function Loading() {
  return (
    <div className="sec-loading_body">
      <div className="box">
        <div className="b b1"></div>
        <div className="b b2"></div>
        <div className="b b3"></div>
        <div className="b b4"></div>
      </div>
    </div>
  )
}

export default Loading;